const logo = getCdnUrl("assets/logo.svg");
const collapseIcon = getCdnUrl("assets/icons/collapse.svg");
const coin = getCdnUrl("assets/icons/coin.svg");
const wallet = getCdnUrl("assets/icons/wallet.svg");
const bell = getCdnUrl("assets/icons/bell.svg");
const speaker = getCdnUrl("assets/icons/speaker.svg");
const downArrow = getCdnUrl("assets/icons/down-arrow.svg");
const edit = getCdnUrl("assets/icons/edit.svg");
const eliteIcon = getCdnUrl("assets/icons/elite-icon.svg");
const editWhite = getCdnUrl("assets/icons/editWhite.svg");
const sharkRight = getCdnUrl("assets/images/shark-right.svg");
const sharkLeft = getCdnUrl("assets/images/shark-left.svg");
const eliteComingSoon = getCdnUrl("assets/images/elite-coming-soon.png");
const verified = getCdnUrl("assets/icons/verified.svg");
const eye = getCdnUrl("assets/icons/eye.svg");
const eyeOff = getCdnUrl("assets/icons/eye-off.svg");
const copy1 = getCdnUrl("assets/icons/copy1.svg");
const copy2 = getCdnUrl("assets/icons/copy2.svg");
const info = getCdnUrl("assets/icons/info.svg");
const upload = getCdnUrl("assets/icons/upload.svg");
const view = getCdnUrl("assets/icons/view.svg");
const tradeCoin = getCdnUrl("assets/icons/trade-coin.svg");
const nftCoin = getCdnUrl("assets/icons/nft-coin.svg");
const infoOutlined = getCdnUrl("assets/icons/info-outlined.svg");
const search = getCdnUrl("assets/icons/search.svg");
const bin = getCdnUrl("assets/icons/delete.svg");
const success = getCdnUrl("assets/icons/success.svg");
const fail = getCdnUrl("assets/icons/fail.svg");
const redBin = getCdnUrl("assets/icons/red-bin.svg");
const closeButton = getCdnUrl("assets/icons/close-button.svg");

// coins
const coinsBlue = getCdnUrl("assets/icons/coins/coins-blue.svg");
const coinsGreen = getCdnUrl("assets/icons/coins/coins-green.svg");
const usdt = getCdnUrl("assets/icons/coins/usdt.svg");
const btc = getCdnUrl("assets/icons/coins/btc.svg");
const bnb = getCdnUrl("assets/icons/coins/bnb.svg");
const eth = getCdnUrl("assets/icons/coins/eth.svg");
const shib = getCdnUrl("assets/icons/coins/shib.svg");
const link = getCdnUrl("assets/icons/coins/link.svg");
const sol = getCdnUrl("assets/icons/coins/sol.svg");
const tether3d = getCdnUrl("assets/icons/coins/tether-3d.svg");
const bitcoin3d = getCdnUrl("assets/icons/coins/bitcoin-3d.svg");
const solana3d = getCdnUrl("assets/icons/coins/solana-3d.svg");
const binance3d = getCdnUrl("assets/icons/coins/binance-3d.svg");
const ethereum3d = getCdnUrl("assets/icons/coins/ethereum-3d.svg");
const shibainu3d = getCdnUrl("assets/icons/coins/shibainu-3d.svg");
const chainlink3d = getCdnUrl("assets/icons/coins/chainlink-3d.svg");

// background
const waves = getCdnUrl("assets/backgrounds/waves.svg");
const purpleDots = getCdnUrl("assets/backgrounds/purple-dots.png");
const city = getCdnUrl("assets/backgrounds/city.png");
const gameScreenBackground = getCdnUrl("assets/backgrounds/game-screen.png");
const modalBackground = getCdnUrl("assets/backgrounds/modal-bg.png");

//sidebar
const briefcase = getCdnUrl("assets/icons/sidebar/briefcase.svg");
const casino = getCdnUrl("assets/icons/sidebar/casino.svg");
const challenge = getCdnUrl("assets/icons/sidebar/challenge.svg");
const dashboard = getCdnUrl("assets/icons/sidebar/dashboard.svg");
const dexchange = getCdnUrl("assets/icons/sidebar/dexchange.svg");
const jackpot = getCdnUrl("assets/icons/sidebar/jackpot.svg");
const nft = getCdnUrl("assets/icons/sidebar/nft.svg");
const play = getCdnUrl("assets/icons/sidebar/play.svg");
const prediction = getCdnUrl("assets/icons/sidebar/prediction.svg");
const rankings = getCdnUrl("assets/icons/sidebar/rankings.svg");
const referrals = getCdnUrl("assets/icons/sidebar/referrals.svg");
const sports = getCdnUrl("assets/icons/sidebar/sports.svg");
const star = getCdnUrl("assets/icons/sidebar/star.svg");
const trophy = getCdnUrl("assets/icons/sidebar/trophy.svg");
const vip = getCdnUrl("assets/icons/sidebar/vip.svg");
const games = getCdnUrl("assets/icons/sidebar/games.svg");
const roulette = getCdnUrl("assets/icons/sidebar/roulette.svg");
const originals = getCdnUrl("assets/icons/sidebar/originals.png");
const favIcon = getCdnUrl("assets/icons/sidebar/fav.svg");
const blackjack = getCdnUrl("assets/icons/sidebar/blackjack.svg");
const newOnSharkroll = getCdnUrl("assets/icons/sidebar/new-on-sharkroll.svg");
const sharkrollBonuses = getCdnUrl(
  "assets/icons/sidebar/sharkroll-bonuses.svg",
);
const more = getCdnUrl("assets/icons/sidebar/more.svg");

// sidebar submenus
const badminton = getCdnUrl("assets/icons/sidebar/submenu/badminton.svg");
const baseball = getCdnUrl("assets/icons/sidebar/submenu/baseball.svg");
const basketball = getCdnUrl("assets/icons/sidebar/submenu/basketball.svg");
const bingo = getCdnUrl("assets/icons/sidebar/submenu/bingo.svg");
const cricket = getCdnUrl("assets/icons/sidebar/submenu/cricket.svg");
const dragontower = getCdnUrl("assets/icons/sidebar/submenu/dragontower.svg");
const golf = getCdnUrl("assets/icons/sidebar/submenu/golf.svg");
const handhockey = getCdnUrl("assets/icons/sidebar/submenu/handhockey.svg");
const hilo = getCdnUrl("assets/icons/sidebar/submenu/hilo.svg");
const limbo = getCdnUrl("assets/icons/sidebar/submenu/limbo.svg");
const patchinko = getCdnUrl("assets/icons/sidebar/submenu/patchinko.svg");
const scratchcard = getCdnUrl("assets/icons/sidebar/submenu/scratchcard.svg");
const slide = getCdnUrl("assets/icons/sidebar/submenu/slide.svg");
const soccer = getCdnUrl("assets/icons/sidebar/submenu/soccer.svg");
const spinwheel = getCdnUrl("assets/icons/sidebar/submenu/spinwheel.svg");
const tabletennis = getCdnUrl("assets/icons/sidebar/submenu/tabletennis.svg");
const tennis = getCdnUrl("assets/icons/sidebar/submenu/tennis.svg");
const volleyball = getCdnUrl("assets/icons/sidebar/submenu/volleyball.svg");
const mybet = getCdnUrl("assets/icons/sidebar/submenu/mybet.svg");
const live = getCdnUrl("assets/icons/sidebar/submenu/live.svg");
const schedule = getCdnUrl("assets/icons/sidebar/submenu/schedule.svg");
const seemore = getCdnUrl("assets/icons/sidebar/submenu/seemore.svg");
const marineMystique = getCdnUrl(
  "assets/icons/sidebar/submenu/marine-mystique.svg",
);
const sharkDrift = getCdnUrl("assets/icons/sidebar/submenu/shark-drift.svg");
const challange = getCdnUrl("assets/icons/sidebar/submenu/challange.svg");
const battle = getCdnUrl("assets/icons/sidebar/submenu/battle.svg");
const luckyLoot = getCdnUrl("assets/icons/sidebar/submenu/lucky-loot.svg");
const jackpotDraw = getCdnUrl("assets/icons/sidebar/submenu/jackpotDraw.svg");
const bouns = getCdnUrl("assets/icons/sidebar/submenu/bouns.svg");
const ranking = getCdnUrl("assets/icons/sidebar/submenu/ranking.svg");
const maintenance = getCdnUrl("assets/icons/sidebar/submenu/maintenance.svg");
const adminModule = getCdnUrl("assets/icons/sidebar/submenu/admin-module.svg");

// footer - social
const facebookSocial = getCdnUrl("assets/icons/social/facebook.svg");
const instagramSocial = getCdnUrl("assets/icons/social/instagram.svg");
const discordSocial = getCdnUrl("assets/icons/social/discord.svg");
const xSocial = getCdnUrl("assets/icons/social/x.svg");
const telegram = getCdnUrl("assets/icons/social/telegram.svg");

// chatbar
const chat = getCdnUrl("assets/icons/chatbar/chat.svg");
const usersGreen = getCdnUrl("assets/icons/chatbar/users-green.svg");
const send = getCdnUrl("assets/icons/chatbar/send.svg");
const arrowDown = getCdnUrl("assets/icons/chatbar/arrow-down.svg");
const arrowLeft = getCdnUrl("assets/icons/chatbar/arrow-left.svg");
const greenOnline = getCdnUrl("assets/icons/chatbar/green-online.svg");
const arrowUp = getCdnUrl("assets/icons/chatbar/arrow-up.svg");
const chatClose = getCdnUrl("assets/icons/chatbar/chat-close.svg");
const chatInfo = getCdnUrl("assets/icons/chatbar/chat-info.svg");
const chatEmoji = getCdnUrl("assets/icons/chatbar/chat-emoji.svg");
const chatGif = getCdnUrl("assets/icons/chatbar/chat-gif.svg");
const chatPlus = getCdnUrl("assets/icons/chatbar/chat-plus.svg");

// chatbar users
const usr1 = getCdnUrl("assets/icons/chatbar/users/usr1.svg");
const usr2 = getCdnUrl("assets/icons/chatbar/users/usr2.svg");
const usr3 = getCdnUrl("assets/icons/chatbar/users/usr3.svg");
const usr4 = getCdnUrl("assets/icons/chatbar/users/usr4.svg");
const usr5 = getCdnUrl("assets/icons/chatbar/users/usr5.svg");
const usr6 = getCdnUrl("assets/icons/chatbar/users/usr6.svg");
const usr7 = getCdnUrl("assets/icons/chatbar/users/usr7.svg");
const usr8 = getCdnUrl("assets/icons/chatbar/users/usr8.svg");
const usr9 = getCdnUrl("assets/icons/chatbar/users/usr9.svg");
const usr10 = getCdnUrl("assets/icons/chatbar/users/usr10.svg");

// bottom bar
const bet = getCdnUrl("assets/icons/bottombar/bet.svg");
const favourite = getCdnUrl("assets/icons/bottombar/favourite.svg");
const referral = getCdnUrl("assets/icons/bottombar/referral.svg");
const trade = getCdnUrl("assets/icons/bottombar/trade.svg");

// tabs
const account = getCdnUrl("assets/icons/tabs/account.svg");
const clock = getCdnUrl("assets/icons/tabs/clock.svg");
const rakebacks = getCdnUrl("assets/icons/tabs/rakebacks.svg");
const receipt = getCdnUrl("assets/icons/tabs/receipt.svg");
const settings = getCdnUrl("assets/icons/tabs/settings.svg");
const lobby = getCdnUrl("assets/icons/tabs/lobby.svg");
const owned = getCdnUrl("assets/icons/tabs/owned.svg");
const slots = getCdnUrl("assets/icons/tabs/slots.svg");
const shows = getCdnUrl("assets/icons/tabs/shows.svg");
const liveCasino = getCdnUrl("assets/icons/tabs/live-casino.svg");
const sidebets = getCdnUrl("assets/icons/tabs/sidebets.svg");
const battles = getCdnUrl("assets/icons/tabs/battles.svg");
const nftIcon = getCdnUrl("assets/icons/tabs/nftTableIcon.svg");
const coinIcon = getCdnUrl("assets/icons/tabs/coinTableIcon.svg");
const cashIcon = getCdnUrl("assets/icons/tabs/cashTableIcon.svg");

// tables
const won = getCdnUrl("assets/icons/won.svg");
const loss = getCdnUrl("assets/icons/loss.svg");
const pending = getCdnUrl("assets/icons/pending.svg");
const dollar = getCdnUrl("assets/icons/dollar.svg");

// nfts
const nft1 = getCdnUrl("assets/images/nfts/nft1.svg");
const nft2 = getCdnUrl("assets/images/nfts/nft2.svg");
const dollar3d = getCdnUrl("assets/images/nfts/dollar-3d.svg");

const vipCrown = getCdnUrl("assets/icons/vip-crown.svg");

// profile dropdown
const article = getCdnUrl("assets/icons/profileDropdown/article.svg");
const blog = getCdnUrl("assets/icons/profileDropdown/blog.svg");
const cases = getCdnUrl("assets/icons/profileDropdown/cases.svg");
const document = getCdnUrl("assets/icons/profileDropdown/document.svg");
const faq = getCdnUrl("assets/icons/profileDropdown/faq.svg");
const glossary = getCdnUrl("assets/icons/profileDropdown/glossary.svg");
const helpCenter = getCdnUrl("assets/icons/profileDropdown/help-center.svg");
const profile = getCdnUrl("assets/icons/profileDropdown/profile.svg");
const support = getCdnUrl("assets/icons/profileDropdown/support.svg");
const topup = getCdnUrl("assets/icons/profileDropdown/topup.svg");
const withdraw = getCdnUrl("assets/icons/profileDropdown/withdraw.svg");
const russiaFlag = getCdnUrl("assets/icons/profileDropdown/russia-flag.svg");

// recent-bets
const crash1 = getCdnUrl("assets/images/recent-bets/crash1.svg");
const crash2 = getCdnUrl("assets/images/recent-bets/crash2.svg");
const crash3 = getCdnUrl("assets/images/recent-bets/crash3.svg");
const mines1 = getCdnUrl("assets/images/recent-bets/mines1.svg");
const mines2 = getCdnUrl("assets/images/recent-bets/mines2.svg");
const mines3 = getCdnUrl("assets/images/recent-bets/mines3.svg");
const player = getCdnUrl("assets/images/recent-bets/player.svg");

//login
const loginBg = getCdnUrl("assets/backgrounds/login/login.png");
const signupBg = getCdnUrl("assets/backgrounds/login/signup.png");
const xIcon = getCdnUrl("assets/icons/login/xIcon.svg");
const facebook = getCdnUrl("assets/icons/login/facebook.svg");
const discord = getCdnUrl("assets/icons/login/discord.svg");
const meta = getCdnUrl("assets/icons/login/meta.svg");
const greenCheck = getCdnUrl("assets/icons/login/greenCheckIcon.svg");
const defaultCheck = getCdnUrl("assets/icons/login/defaultCheckIcon.svg");
const hidepassword = getCdnUrl("assets/icons/login/hidePassword.svg");
const showpassword = getCdnUrl("assets/icons/login/showpassword.svg");

// Lobby Images - slots
const slotsGameCard1 = getCdnUrl("assets/images/lobby/slots/GameCard1.svg");
const slotsGameCard2 = getCdnUrl("assets/images/lobby/slots/GameCard2.svg");
const slotsGameCard3 = getCdnUrl("assets/images/lobby/slots/GameCard3.svg");
const slotsGameCard4 = getCdnUrl("assets/images/lobby/slots/GameCard4.svg");
const slotsGameCard5 = getCdnUrl("assets/images/lobby/slots/GameCard5.svg");
const slotsGameCard6 = getCdnUrl("assets/images/lobby/slots/GameCard6.svg");

// Lobby Images - live-casino
const liveCasinoGameCard1 = getCdnUrl(
  "assets/images/lobby/live-casino/GameCard1.svg",
);
const liveCasinoGameCard2 = getCdnUrl(
  "assets/images/lobby/live-casino/GameCard2.svg",
);
const liveCasinoGameCard3 = getCdnUrl(
  "assets/images/lobby/live-casino/GameCard3.svg",
);
const liveCasinoGameCard4 = getCdnUrl(
  "assets/images/lobby/live-casino/GameCard4.svg",
);
const liveCasinoGameCard5 = getCdnUrl(
  "assets/images/lobby/live-casino/GameCard5.svg",
);
const liveCasinoGameCard6 = getCdnUrl(
  "assets/images/lobby/live-casino/GameCard6.svg",
);

// Lobby Images - game-shows
const gameShowGameCard1 = getCdnUrl(
  "assets/images/lobby/game-shows/GameCard1.svg",
);
const gameShowGameCard2 = getCdnUrl(
  "assets/images/lobby/game-shows/GameCard2.svg",
);
const gameShowGameCard3 = getCdnUrl(
  "assets/images/lobby/game-shows/GameCard3.svg",
);
const gameShowGameCard4 = getCdnUrl(
  "assets/images/lobby/game-shows/GameCard4.svg",
);
const gameShowGameCard5 = getCdnUrl(
  "assets/images/lobby/game-shows/GameCard5.svg",
);
const gameShowGameCard6 = getCdnUrl(
  "assets/images/lobby/game-shows/GameCard6.svg",
);

// Lobby Images - new-releases
const newReleaseGameCard1 = getCdnUrl(
  "assets/images/lobby/new-releases/GameCard1.svg",
);

// Lobby Images - originals
const originalGameCard1 = getCdnUrl(
  "assets/images/lobby/originals/GameCard1.svg",
);
const originalGameCard2 = getCdnUrl(
  "assets/images/lobby/originals/GameCard2.svg",
);
const originalGameCard3 = getCdnUrl(
  "assets/images/lobby/originals/GameCard3.svg",
);
const originalGameCard4 = getCdnUrl(
  "assets/images/lobby/originals/GameCard4.svg",
);
const originalGameCard5 = getCdnUrl(
  "assets/images/lobby/originals/GameCard5.svg",
);
const originalGameCard6 = getCdnUrl(
  "assets/images/lobby/originals/GameCard6.svg",
);

// Lobby Images - bonus-battles
const bonusBattleGameCard1 = getCdnUrl(
  "assets/images/lobby/bonus-battles/GameCard1.svg",
);
const bonusBattleGameCard2 = getCdnUrl(
  "assets/images/lobby/bonus-battles/GameCard2.svg",
);

// Lobby Images - providers
const providersGameCard1 = getCdnUrl(
  "assets/images/lobby/providers/GameCard1.svg",
);

// Games icons
const gatesOfOlympus = getCdnUrl("assets/icons/games/gatesOfOlympus.svg");

// Prediction Game
const historyIcon = getCdnUrl("assets/icons/predictionGame/history.svg");
const infoIcon = getCdnUrl("assets/icons/predictionGame/info.svg");
const leaderboardIcon = getCdnUrl(
  "assets/icons/predictionGame/leaderboard.svg",
);
const trophyIcon = getCdnUrl("assets/icons/predictionGame/trophyIcon.svg");
const cardBackground = getCdnUrl("assets/icons/predictionGame/cardbg.svg");
const candleIcon = getCdnUrl("assets/icons/predictionGame/candleIcon.svg");
const downIcon = getCdnUrl("assets/icons/predictionGame/down.svg");

//Prediction
const calculating = getCdnUrl("assets/prediction/calculating.svg");
const predicloss = getCdnUrl("assets/prediction/loss.svg");
const predicwon = getCdnUrl("assets/prediction/won.svg");
const proIcon = getCdnUrl("assets/prediction/proIcon.svg");
const rakebackIcon = getCdnUrl("assets/prediction/rakebackIcon.svg");
const plusIcon = getCdnUrl("assets/prediction/plusIcon.svg");
const minusIcon = getCdnUrl("assets/prediction/minusIcon.svg");
const tradingview = getCdnUrl("assets/prediction/tradingView.svg");
const LeftArrowBlue = getCdnUrl("assets/prediction/LeftArrowBlue.svg");
const LeftArrowGray = getCdnUrl("assets/prediction/LeftArrowGray.svg");
const RightArrowBlue = getCdnUrl("assets/prediction/RightArrowBlue.svg");
const RightArrowGray = getCdnUrl("assets/prediction/RightArrowGray.svg");

//leaderboard
const upBlackArrow = getCdnUrl(
  "assets/prediction/leaderboard/upBlackArrow.svg",
);
const downBlackArrow = getCdnUrl(
  "assets/prediction/leaderboard/downBlackArrow.svg",
);
const winTrophy = getCdnUrl("assets/prediction/leaderboard/winTrophy.svg");
const pnlChart = getCdnUrl("assets/prediction/leaderboard/pnlChart.svg");
const dollerIcon = getCdnUrl("assets/prediction/dollerIcon.svg");

//profile
const claimIcon = getCdnUrl("assets/icons/profile/claimIcon.svg");
const setting = getCdnUrl("assets/icons/profile/setting.svg");
const referralIcon = getCdnUrl("assets/icons/profile/referrals.svg");
const sharkCoin = getCdnUrl("assets/icons/profile/sharkCoin.svg");
const sharkCoin100 = getCdnUrl("assets/icons/profile/sharkCoin100.svg");
const bettleSide = getCdnUrl("assets/icons/profile/bettle.svg");
const instanIconSide = getCdnUrl("assets/icons/profile/instanIconSide.svg");
const lobbyside = getCdnUrl("assets/icons/profile/lobbyside.svg");
const otherside = getCdnUrl("assets/icons/profile/otherside.svg");
const sidebet = getCdnUrl("assets/icons/profile/sidebet.svg");
const copyblue = getCdnUrl("assets/icons/profile/copyBlueIcon.svg");
const copywhite = getCdnUrl("assets/icons/profile/copyWhite.svg");

//rake
const nextWhite = getCdnUrl("assets/icons/rakeback/nextWhiteArrow.svg");
const nextDark = getCdnUrl("assets/icons/rakeback/nextDarkArrow.svg");
const prevWhite = getCdnUrl("assets/icons/rakeback/prevWhiteArrow.svg");
const prevDark = getCdnUrl("assets/icons/rakeback/prevDarkArrow.svg");

//sharkdex
const tradeIcon = getCdnUrl("assets/icons/shrakdex/tradeIcon.svg");
const liquidity = getCdnUrl("assets/icons/shrakdex/liquidity.svg");
const buyandburn = getCdnUrl("assets/icons/shrakdex/buyandburnIcon.svg");
const deleteIcon = getCdnUrl("assets/icons/admin/deleteIcon.svg");
const usdIcon = getCdnUrl("assets/icons/shrakdex/usdIcon.svg");
const shrlIcon = getCdnUrl("assets/icons/shrakdex/shrlIcon.svg");
const successIcon = getCdnUrl("assets/icons/shrakdex/successIcon.svg");
const failIcon = getCdnUrl("assets/icons/shrakdex/failIcon.svg");
const blueBurn = getCdnUrl("assets/icons/shrakdex/blueBurnIcon.svg");
const orangeBurn = getCdnUrl("assets/icons/shrakdex/orangeBurnIcon.svg");
const infoDarkIcon = getCdnUrl("assets/icons/shrakdex/infoDarkIcon.svg");
const shrlIcon50x50 = getCdnUrl("assets/icons/shrakdex/shrlIcon50x50.svg");
const greenPriceUp = getCdnUrl("assets/icons/shrakdex/greenPriceUp.svg");
const plusIconLiquidity = getCdnUrl("assets/icons/shrakdex/plusIcon.svg");
const minusIconLiquidity = getCdnUrl("assets/icons/shrakdex/minIcon.svg");
const yellowDoubleArrow = getCdnUrl(
  "assets/icons/shrakdex/yellowDoubleArrow.svg",
);
const shrkGreenUp = getCdnUrl("assets/icons/shrakdex/shrkGreenUp.svg");
const chartIcon = getCdnUrl("assets/icons/shrakdex/chartIcon.svg");
const chartSettingIcon = getCdnUrl(
  "assets/icons/shrakdex/chartSettingIcon.svg",
);
const expandChartIcon = getCdnUrl("assets/icons/shrakdex/expandChartIcon.svg");

//lobbytabs
const lobbyIcon = getCdnUrl("assets/lobby/slot.svg");
const slotIcon = getCdnUrl("assets/lobby/slot.svg");
const showIcon = getCdnUrl("assets/lobby/show.svg");
const othersIcon = getCdnUrl("assets/lobby/others.svg");
const instatIcon = getCdnUrl("assets/lobby/instant.svg");
const originalIcon = getCdnUrl("assets/lobby/original.svg");
const liveCasineoIcon = getCdnUrl("assets/lobby/liveCasino.svg");

const deletebutton = getCdnUrl("assets/icons/partnership/deleteButton.svg");
const copyIcon = getCdnUrl("assets/icons/partnership/copy.svg");

// staking
const stakingIcon = getCdnUrl("assets/icons/staking/icon.svg");
const successIconStaking = getCdnUrl("assets/icons/staking/success.svg");
const failIconStaking = getCdnUrl("assets/icons/staking/fail.svg");

//wallet
const walletUpIcon = getCdnUrl("assets/icons/wallet/upArrowBlue.svg");
const walletDownIcon = getCdnUrl("assets/icons/wallet/downArrowBlue.svg");
const logoMobile = getCdnUrl("assets/icons/login/logoMobile.svg");

//faq
const QuestionIcon = getCdnUrl("assets/icons/faq/question.svg");
import { getCdnUrl } from "@/lib/utils";

// home
const timeCardImg = getCdnUrl("assets/backgrounds/home/time-card-img.svg");
const spinWheelImg = getCdnUrl("assets/backgrounds/home/spinwheel-img.svg");
const scratchcardImg = getCdnUrl("assets/backgrounds/home/scratchcard-img.svg");
const sharkTowerImg = getCdnUrl("assets/backgrounds/home/sharktower-img.svg");
const limboImg = getCdnUrl("assets/backgrounds/home/limbo-img.svg");
const slideImg = getCdnUrl("assets/backgrounds/home/slide-img.svg");
const hiloImg = getCdnUrl("assets/backgrounds/home/hilo-img.svg");
const bingoImg = getCdnUrl("assets/backgrounds/home/bingo-img.svg");
const vipSubscriptionImg = getCdnUrl(
  "assets/backgrounds/home/vip-subscription-img.svg",
);
const jackpotDrawBg = getCdnUrl("assets/backgrounds/home/jackpot-draw-bg.svg");
const wavesCardBg = getCdnUrl("assets/backgrounds/home/waves-card-bg.svg");
const challengesImg = getCdnUrl("assets/backgrounds/home/challenges-img.svg");
const tournamentsImg = getCdnUrl("assets/backgrounds/home/tournaments-img.svg");
const originalGameImg = getCdnUrl(
  "assets/backgrounds/home/original-game-img.svg",
);
const casinoImg = getCdnUrl("assets/backgrounds/home/casino-img.svg");
const predictionImg = getCdnUrl("assets/backgrounds/home/prediction-img.svg");
const nftMarketplaceImg = getCdnUrl(
  "assets/backgrounds/home/nft-marketplace-img.svg",
);
const sportsImg = getCdnUrl("assets/backgrounds/home/sports-img.svg");
const luckLootDayImg = getCdnUrl(
  "assets/backgrounds/home/luck-loot-day-img.svg",
);
const bonusImg = getCdnUrl("assets/backgrounds/home/bonus-img.svg");
const rewardsImg = getCdnUrl("assets/backgrounds/home/rewards-img.svg");
const dexImg = getCdnUrl("assets/backgrounds/home/dex-img.svg");
const dexBg = getCdnUrl("assets/backgrounds/home/dex-bg.svg");
const rankingsImg = getCdnUrl("assets/backgrounds/home/rankings-img.svg");
const referralImg = getCdnUrl("assets/backgrounds/home/referral-img.svg");
const predatorImg = getCdnUrl("assets/backgrounds/home/predator.svg");
const predatorImgMobile = getCdnUrl(
  "assets/backgrounds/home/predator-mobile.png",
);
const marineMystiqueImg = getCdnUrl(
  "assets/backgrounds/home/marine-mystique.svg",
);
const marineMystiqueImgMobile = getCdnUrl(
  "assets/backgrounds/home/marine-mystique-mobile.png",
);
const sharkDriftImg = getCdnUrl("assets/backgrounds/home/shark-drift.svg");
const partnership = getCdnUrl("assets/backgrounds/home/partnership.svg");
const partnershipMobile = getCdnUrl(
  "assets/backgrounds/home/partnership-mobile.svg",
);
const referralMobile = getCdnUrl("assets/backgrounds/home/referral-mobile.svg");

export {
  logo,
  collapseIcon,
  coin,
  wallet,
  bell,
  speaker,
  downArrow,
  waves,
  verified,
  eye,
  eyeOff,
  copy1,
  copy2,
  info,
  upload,
  view,
  tradeCoin,
  nftCoin,
  infoOutlined,
  search,
  bin,
  success,
  fail,
  redBin,
  closeButton,

  // sidebar
  briefcase,
  casino,
  challenge,
  dashboard,
  dexchange,
  jackpot,
  nft,
  play,
  prediction,
  rankings,
  referrals,
  sports,
  star,
  trophy,
  vip,
  games,
  roulette,
  edit,
  eliteIcon,
  editWhite,
  coinsBlue,
  coinsGreen,
  purpleDots,
  sharkRight,
  sharkLeft,
  eliteComingSoon,
  city,
  account,
  clock,
  rakebacks,
  receipt,
  settings,
  lobby,
  owned,
  slots,
  shows,
  liveCasino,
  sidebets,
  battles,
  originals,
  favIcon,
  blackjack,
  newOnSharkroll,
  more,

  // sidebar submenus
  badminton,
  baseball,
  basketball,
  bingo,
  cricket,
  dragontower,
  golf,
  handhockey,
  hilo,
  limbo,
  patchinko,
  scratchcard,
  slide,
  soccer,
  spinwheel,
  tabletennis,
  tennis,
  volleyball,
  mybet,
  live,
  schedule,
  seemore,
  marineMystique,
  sharkDrift,
  challange,
  battle,
  sharkrollBonuses,
  luckyLoot,
  jackpotDraw,
  bouns,
  ranking,
  maintenance,
  adminModule,

  // footer - social
  facebookSocial,
  instagramSocial,
  discordSocial,
  xSocial,
  telegram,

  // chatbar
  chat,
  usersGreen,
  send,
  arrowDown,
  arrowLeft,
  greenOnline,
  arrowUp,
  chatClose,
  chatInfo,
  chatEmoji,
  chatGif,
  chatPlus,

  // chatbar users
  usr1,
  usr2,
  usr3,
  usr4,
  usr5,
  usr6,
  usr7,
  usr8,
  usr9,
  usr10,

  // bottom bar
  bet,
  favourite,
  referral,
  trade,

  // coins
  usdt,
  btc,
  sol,
  bnb,
  eth,
  shib,
  link,
  tether3d,
  bitcoin3d,
  solana3d,
  binance3d,
  ethereum3d,
  shibainu3d,
  chainlink3d,

  // tables
  won,
  loss,
  pending,
  dollar,

  // nfts
  nft1,
  nft2,
  dollar3d,

  // Lobby Images - slots
  slotsGameCard1,
  slotsGameCard2,
  slotsGameCard3,
  slotsGameCard4,
  slotsGameCard5,
  slotsGameCard6,

  // Lobby Images - live-casino
  liveCasinoGameCard1,
  liveCasinoGameCard2,
  liveCasinoGameCard3,
  liveCasinoGameCard4,
  liveCasinoGameCard5,
  liveCasinoGameCard6,

  // Lobby Images - game-shows
  gameShowGameCard1,
  gameShowGameCard2,
  gameShowGameCard3,
  gameShowGameCard4,
  gameShowGameCard5,
  gameShowGameCard6,

  // Lobby Images - new-releases
  newReleaseGameCard1,

  // Lobby Images - originals
  originalGameCard1,
  originalGameCard2,
  originalGameCard3,
  originalGameCard4,
  originalGameCard5,
  originalGameCard6,

  // Lobby Images - bonus-battles
  bonusBattleGameCard1,
  bonusBattleGameCard2,

  // Lobby Images - providers
  providersGameCard1,

  // games icons
  gatesOfOlympus,

  // backgrounds
  gameScreenBackground,
  modalBackground,

  // home
  sharkDriftImg,
  marineMystiqueImg,
  marineMystiqueImgMobile,
  predatorImg,
  predatorImgMobile,
  timeCardImg,
  spinWheelImg,
  scratchcardImg,
  sharkTowerImg,
  limboImg,
  slideImg,
  hiloImg,
  bingoImg,
  vipSubscriptionImg,
  vipCrown,
  jackpotDrawBg,
  wavesCardBg,
  challengesImg,
  tournamentsImg,
  originalGameImg,
  casinoImg,
  predictionImg,
  nftMarketplaceImg,
  sportsImg,
  luckLootDayImg,
  bonusImg,
  rewardsImg,
  dexImg,
  dexBg,
  rankingsImg,
  referralImg,

  // profile dropdown
  article,
  blog,
  cases,
  document,
  faq,
  glossary,
  helpCenter,
  profile,
  support,
  topup,
  withdraw,
  russiaFlag,

  // recent-bets
  crash1,
  crash2,
  crash3,
  mines1,
  mines2,
  mines3,
  player,

  //login
  loginBg,
  signupBg,
  xIcon,
  facebook,
  discord,
  meta,
  greenCheck,
  defaultCheck,
  hidepassword,
  showpassword,

  //prediction game
  historyIcon,
  infoIcon,
  leaderboardIcon,
  trophyIcon,
  cardBackground,

  //prediction
  calculating,
  predicloss,
  predicwon,
  proIcon,
  rakebackIcon,
  minusIcon,
  plusIcon,
  tradingview,
  LeftArrowBlue,
  LeftArrowGray,
  RightArrowBlue,
  RightArrowGray,

  //leaderboard
  upBlackArrow,
  downBlackArrow,
  winTrophy,
  pnlChart,
  dollerIcon,

  //profile
  claimIcon,

  //rake
  nextWhite,
  nextDark,
  prevWhite,
  prevDark,

  //sharkdex
  tradeIcon,
  buyandburn,
  liquidity,
  deleteIcon,
  usdIcon,
  shrlIcon,
  successIcon,
  failIcon,
  blueBurn,
  orangeBurn,
  infoDarkIcon,
  shrlIcon50x50,
  greenPriceUp,
  plusIconLiquidity,
  minusIconLiquidity,
  yellowDoubleArrow,
  shrkGreenUp,
  chartIcon,
  chartSettingIcon,
  expandChartIcon,
  candleIcon,
  downIcon,
  lobbyIcon,
  showIcon,
  othersIcon,
  instatIcon,
  slotIcon,
  originalIcon,
  liveCasineoIcon,
  sharkCoin,
  sharkCoin100,
  referralIcon,
  setting,
  bettleSide,
  instanIconSide,
  lobbyside,
  otherside,
  sidebet,
  deletebutton,
  copyIcon,
  copyblue,
  copywhite,
  nftIcon,
  coinIcon,
  cashIcon,
  successIconStaking,
  stakingIcon,
  failIconStaking,
  partnership,
  partnershipMobile,
  referralMobile,
  walletUpIcon,
  walletDownIcon,
  logoMobile,

  //faq
  QuestionIcon,
};
